import createUrlBuilder from 'utilities/url.builder.utils';
import { getRequest } from 'utilities/service.utils';
import AppService from './app.service.context';

export const fetchTimeZones = async () => {
  const urlBuilder = createUrlBuilder('/system/domains/TIMEZONE');
  return await getRequest(AppService, urlBuilder.toString());
};

export const fetchEmergencyContactsService = async (coordinate: any) => {
  const urlBuilder = createUrlBuilder(
    `/community/organisations/emergency?location=%7B%22type%22%3A%22Point%22%2C%22coordinates%22%3A%5B${coordinate}%5D%7D`
  );
  const result =
    urlBuilder && (await getRequest(AppService, urlBuilder.toString()));
  return result;
};
